import script from "./songlist.vue?vue&type=script&setup=true&lang=js"
export * from "./songlist.vue?vue&type=script&setup=true&lang=js"

import "./songlist.vue?vue&type=style&index=0&id=525f4332&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525f4332"]])

export default __exports__